import React, {useEffect, useRef, useState} from 'react';
import Box from '@mui/material/Box';
import MaterialReactTable, { MRT_RowSelectionState, MRT_TableInstance } from 'material-react-table';
//import type { MRT_Row } from 'material-react-table';
//Import Material React Table Translations
import { MRT_Localization_FA } from 'material-react-table/locales/fa';
import { Button, IconButton, Tooltip } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import FilterIcon from '@mui/icons-material/FilterAlt';
import ExportIcon from '@mui/icons-material/FilePresent';
//import { ExportToCsv } from 'export-to-csv';
import { IMrt_grid_prop_Client } from './IMrt_grid_prop';
import type { SortingState } from '@tanstack/react-table';
import type { Virtualizer } from '@tanstack/react-virtual';
import { CSVLink } from "react-csv";

function getWindowSize() {
  const {innerWidth, innerHeight} = window;
  return {innerWidth, innerHeight};
}

const MrtGridVirtual = ({
    disableStickyFooter,
    stickyOffset,
    enableGrouping,
    disableFilters,
    disableColumnResizing,
    disableColumnFilterModes,
    enableDensityToggle: disableDensityToggle,
    disableStickyHeader,
    disableSorting,
    disableFullScreenToggle,
    disablePagination,
    disableTableFooter,
    disableHiding,
    disableTopToolbar,
    disableBottomToolbar,
    disableColumnActions,
    
    enableColumnOrdering,
    enableColumnDragging,
    enableClickToCopy,
    enablePinning,
    enableRowSelection,
    enableSelectAll,
    enableMultiRowSelection,
    enableExcelExport,
    enableDarkMode,
    enableExpandAll,

    headerColor,
    initialState_showColumnFilters,
    initialState_paginationSize,
    initialState_columnPinning_left,
    initialState_columnPinning_right,
    initialState_columnVisibility,
    isLoading,
    columns,
    data,
    onNeedData,
    onCustomFilterClick,
    rowActions,
    topToolbarCustomActions,
    onRowSelection,
    disableAutoRenderRowActions,
    rowActionsRenderer,
    renderDetailPanel,
    // muiExpandButtonProps,
    // muiDetailPanelProps
     }: IMrt_grid_prop_Client ) => {
    
    useEffect(() => {
      //csvExporter.options.headers = columns.map((c:any) => c.header);
    }, [columns]);    
    
    const [windowSize, setWindowSize] = React.useState(getWindowSize());

    const setRefetch = async() =>  {
      await onNeedData();
    }
    
    React.useEffect(() => {
      function handleWindowResize() {
        setWindowSize(getWindowSize());
      }

      window.addEventListener('resize', handleWindowResize);

      return () => {
        window.removeEventListener('resize', handleWindowResize);
      };
    }, []);

  // --------------- virtual :
  
  //optionally access the underlying virtualizer instance
  const rowVirtualizerInstanceRef =
    useRef<Virtualizer<HTMLDivElement, HTMLTableRowElement>>(null);

  const [sorting, setSorting] = useState<SortingState>([]);

  useEffect(() => {
    //scroll to the top of the table when the sorting changes
    rowVirtualizerInstanceRef.current?.scrollToIndex(0);
  }, [sorting]);

  
  const craeteExcelData = (dt: any) => {
    return dt.map((m:any) => {
      columns.forEach((col:any) => {
        if(col.accessorFn){
          let obj:any = {};
          obj[`${col.id}`] = col.accessorFn(m);
          m = {...m, ...obj}
        }
      });
      return m;
    });
  }

  const craeteExcelHeader = () => {
    return columns.map((c:any) =>  {
      return { label: c.header, key: c.id }
    });
  }

  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  useEffect(() => {
    let t = tableInstanceRef.current?.getSelectedRowModel();
    
    if(onRowSelection ){
      if (t?.rows && t?.rows.length > 0){
        enableMultiRowSelection 
            ? onRowSelection(t?.rows.map((m: any)=> m.original)) 
            : onRowSelection(t?.rows[0].original);
      }
      else{
        onRowSelection(undefined);
      }
    }
  }, [rowSelection]);

  const tableInstanceRef = React.useRef<MRT_TableInstance<any>>(null); //ts
  var actionWidth = 6;
    if(rowActions?.length??0 > 0 ){
      rowActions?.map(m => actionWidth += (((m.title??'123456').length) * 8 + 25) );
    }
  return (
    <MaterialReactTable
        tableInstanceRef={tableInstanceRef}
        enableColumnActions={!disableColumnActions}
        enableFilters={!disableFilters}
        enableHiding={!disableHiding}
        enableTableFooter={!disableTableFooter}
        enableClickToCopy={enableClickToCopy}
        enablePagination={!disablePagination}
        enableFullScreenToggle={!disableFullScreenToggle}
        enableSorting={!disableSorting}
        enableColumnFilterModes={!disableColumnFilterModes}
        enableColumnOrdering={enableColumnOrdering}
        enablePinning={enablePinning}
        enableRowActions={rowActions && rowActions.length > 0}
        enableRowSelection={enableRowSelection}
        enableDensityToggle={!disableDensityToggle}
        enableColumnResizing={!disableColumnResizing}
        enableSelectAll={enableSelectAll}
        enableMultiRowSelection={enableMultiRowSelection}

        enableTopToolbar={!disableTopToolbar}
        enableBottomToolbar={!disableBottomToolbar}
        renderRowActions={({ cell,row,table }) => (
          <React.Fragment>
         {!disableAutoRenderRowActions===true &&
          <Box key={row.index} sx={{ display: 'flex', gap: '0.6rem', p: '2px' }}>
            {rowActions?.map(m => 
              <React.Fragment key={row.index} >{(!m.tooltip || !m.icon) &&
                  <Button disabled={m.disabled} style={{display: m.hidden ? "none" : "block"}} key={row.index} color={m.color || 'primary'} variant={m.variant || 'contained'} size={m.size || 'small'} onClick={() => m.handleClick(row.original)}>
                    {m.title} {m.icon}
                  </Button>
               }</React.Fragment>
            )}
            {rowActions?.map(m => <React.Fragment key={row.index} >{(m.tooltip && m.icon) &&
              <Tooltip key={row.index} arrow title={m.tooltip}>
                  <IconButton onClick={() => m.handleClick(row.original)} >
                  {m.title} {m.icon}
                  </IconButton>
              </Tooltip> }</React.Fragment>
            )} 
          </Box>}
          {disableAutoRenderRowActions===true && rowActionsRenderer(cell,row,table)}
          </React.Fragment>
        )}
        displayColumnDefOptions={{
          'mrt-row-actions': {
            header: 'عمليات', //change header text
            size: actionWidth, //make actions column wider
          },
        }}
        enableStickyHeader={!disableStickyHeader}
        enableStickyFooter={!disableStickyFooter}
        muiTableContainerProps={!disableStickyFooter ? 
          { sx: { maxHeight: (windowSize.innerHeight - (stickyOffset || 0)) + 'px' } } : undefined}
        enableGrouping={enableGrouping}
        enableColumnDragging={enableColumnDragging}
        groupedColumnMode = "reorder"
        state={{ isLoading: isLoading, sorting, rowSelection }}
        initialState={{ 
          showColumnFilters: initialState_showColumnFilters, 
          showGlobalFilter: false , 
          columnPinning: { left: initialState_columnPinning_left , right: initialState_columnPinning_right},
          pagination: { pageSize: initialState_paginationSize || 50, pageIndex: 0 }, 
          density: 'compact',
          columnVisibility: initialState_columnVisibility ? Object.assign({},...initialState_columnVisibility) : {},
        }}
        localization={MRT_Localization_FA}
        columns={columns} 
        data={data} 
        renderDetailPanel={renderDetailPanel}
        enableExpandAll={enableExpandAll}
        // muiExpandButtonProps={muiExpandButtonProps}
        // muiDetailPanelProps={muiDetailPanelProps}
        renderTopToolbarCustomActions={({ table }) => (
          <Box sx={{ display: 'flex', gap: '1rem', p: '4px' }}>
            <Tooltip arrow title=" بازخواني اطلاعات">
              <IconButton onClick={() => setRefetch()}>
                <RefreshIcon />
              </IconButton>
            </Tooltip>
            {onCustomFilterClick && <Tooltip arrow title="شرايط گزارش">
              <IconButton onClick={() => onCustomFilterClick()} >
                <FilterIcon />
              </IconButton>
            </Tooltip>}
            {enableExcelExport && <Tooltip arrow title="خروجي اكسل">
              <IconButton>
              <CSVLink data={craeteExcelData(data)} style={{color:'gray'}} headers={craeteExcelHeader()}>
                  <ExportIcon />
                </CSVLink>            
              </IconButton>
            </Tooltip>}
            {topToolbarCustomActions?.map((m,i) =>   
            <React.Fragment key={i}> 
              {(!m.tooltip || !m.icon) &&
                <Button disabled={m.disabled} style={{marginLeft:'2px'}} color={m.color || 'primary'} variant={m.variant || 'contained'} size={m.size || 'small'} onClick={() => m.handleClick(table)}>
                  {m.title} {m.icon}
                </Button>}
            </React.Fragment>)}
            {topToolbarCustomActions?.map((m,i) =>   
            <React.Fragment key={i}> 
              {(m.tooltip && m.icon) &&
                <Tooltip arrow title={m.tooltip}>
                  <IconButton disabled={m.disabled} onClick={() => m.handleClick(table)} >
                    {m.title} {m.icon}
                  </IconButton>
                </Tooltip>}
              </React.Fragment>
            )}
          </Box>
        )}
        muiTableHeadProps={{
          sx: {
            '& tr, tr th': {
              backgroundColor: headerColor ?? (enableDarkMode ? '#003636' : '#e5f6fd'),//'#f0f0f0',//'#e5f6fd',//
              fontSize: '13px',
              padding: '0.6rem'
            },
          }                          
        }}
        muiTableBodyProps={enableRowSelection
          ?{
            sx: {
              '& tr td': {
                fontSize: '13px'
              },
            }         
          }
          :{
          sx: {
            '& tr td': {
              fontSize: '13px'
            },
            '& tr:nth-of-type(odd)': {
              backgroundColor: enableDarkMode ? '#1a1a1a' : '#fafdff'
            },
          }         
        }}

        onSortingChange={setSorting}
        
        rowVirtualizerInstanceRef={rowVirtualizerInstanceRef} //optional
        rowVirtualizerProps={{ overscan: 5 }} //optionally customize the row virtualizer
        columnVirtualizerProps={{ overscan: 2 }} //optionally customize the column virtualizer

        muiTablePaginationProps={{
          rowsPerPageOptions: [20,50,100,200],
        }}
        
        onRowSelectionChange={setRowSelection}
        muiTableBodyRowProps={({ row }) => ({
          //add onClick to row to select upon clicking anywhere in the row
          onClick: (event: any) => {
              console.log(event.target.localName)
            if (event.target.localName != 'button' && event.target.localName != 'text' &&  event.target.localName != 'path' &&  event.target.localName != 'svg') row.toggleSelected();
          },
          sx: { cursor: 'pointer' },
        })}
    />
  );
}

export default MrtGridVirtual;